import moment from "moment";

export function isDateNowOrEarlier(assignmentDate) {
  if (assignmentDate == null) {
    return false;
  }

  const today = moment();
  const when = moment(assignmentDate);
  return when.isBefore(today) || when.isSame(today);
}

export function isClassroomArchived(classroom) {
  return isDateNowOrEarlier(classroom.date_archived);
}

export function assignmentsWithActiveAssigneesOrAreDrafts(assignments) {
  if (!assignments) return [];

  const isActiveClassroom = ({ classroom }) => !isClassroomArchived(classroom);

  return assignments.filter((assignment) => {
    const {
      assignment_classrooms: assignmentClassrooms,
      assignment_groups: assignmentGroups,
      is_draft: isDraft,
    } = assignment;
    return (
      assignmentClassrooms.some(isActiveClassroom) ||
      assignmentGroups?.length > 0 ||
      isDraft
    );
  });
}
